export default __webpack_public_path__ + "static/media/notfound.427b36a3.png";